import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202606",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 22434,
  clicks: 488,
  adsSpendDollars: 1812,
  budgetDollars: 2400,
  salesDollars: 8202,
  bestEstimateRoas: 4.53,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.76,
  newCustomersAcquired: 14,
  reorderConversions: 6,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
